export default __webpack_public_path__ + "static/media/large.b4a90318.jpg";